import { useAuth0 } from "@auth0/auth0-react";
import { Collapse, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import { Box, IconButton } from "@mui/material";
import { Text } from "components";
import AlertDialog from "components/Dialog/index";
import RightDrawer from "components/drawer";
import Loader from "components/loader/Loader";
import NotAuthorized from "components/NotAuthorized";
import { CheckBox } from "components/CheckBox/CheckBox";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import PreSchoolService from "Lib/API/PreSchool";
import { getCurrentRegisteredDate } from "pages/NewEvents/Events/multiDateChanges";
import ParticipantDrawer from "pages/NewEvents/participants/ParticipantDetails/ParticipantDetailsTable/ParticipantDrawer/ParticipantDrawer";
import "pages/NewEvents/participants/ParticipantDetails/ParticipantDetailsTable/index.scss";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router";
import { Status, StatusWrapper } from "../Theme";
import { fontConfig } from "theme/fontConfig";

const Events = ({ member }) => {
  const history = useHistory();

  const { getAccessTokenSilently } = useAuth0();

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [isEventsActive, setIsEventsActive] = useState(true);
  const [confirmClose, setConfirmClose] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [dateAttendanceMap, setDateAttendanceMap] = useState({});
  const [attendedMap, setAttendedMap] = useState({});
  const [attendeeDialog, setAttendeeDialog] = useState(false);
  const [attendeeRow, setAttendeeRow] = useState(null);
  const [attendeeValue, setAttendeeValue] = useState(null);
  const [attendeeDateName, setAttendeeDateName] = useState("");
  const [attendeeLoading, setAttendeeLoading] = useState(false);

  let orgInfo = localStorage?.getItem("organization")
    ? JSON.parse(localStorage?.getItem("organization"))
    : [];

  let authorizedModulesInfo = localStorage?.getItem("authorizedModules")
    ? JSON.parse(localStorage?.getItem("authorizedModules"))
    : [];

  useEffect(() => {
    const status =
      orgInfo?.authorizedModules?.find((item) => item?.moduleName === "events")
        ?.active === true &&
      authorizedModulesInfo?.find((item) => item?.moduleName === "events")
        ?.active === true
        ? true
        : false;
    setIsEventsActive(status);
  }, []);

  useEffect(() => {
    getEventParticipantsHandler();
  }, [getAccessTokenSilently, history, page]);

  const getEventParticipantsHandler = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    const payload = {
      accountId: member?._id,
    };
    PreSchoolService.getEventParticipantsByAccount({
      token,
      payload,
      page: page + 1,
      limit: 30,
    })
      .then((res) => {
        setList(res?.payload?.data || []);
        setTotal(res?.payload?.pagination?.count || 0);
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message || "Something went wrong!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const closeModal = () => {
    setConfirmClose(true);
  };
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenDrawer(false);
  };

  const toggleRow = (id) => {
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleAttendeeChange = (row, value, dateName) => {
    setAttendeeRow(row);
    setAttendeeValue(value);
    setAttendeeDateName(dateName);
    setAttendeeDialog(true);
  };

  const confirmAttendee = async () => {
    try {
      setAttendeeLoading(true);
      const token = await getAccessTokenSilently();
      await PreSchoolService.markAttendee(token, {
        eventId: attendeeRow?.event?._id,
        participantId: attendeeRow._id,
        name: attendeeDateName,
        attendee: attendeeValue,
      });
      if (attendeeDateName) {
        const key = `${attendeeRow._id}__${attendeeDateName}`;
        setDateAttendanceMap((prev) => ({ ...prev, [key]: attendeeValue }));
      } else {
        setAttendedMap((prev) => ({ ...prev, [attendeeRow._id]: attendeeValue }));
      }
      toastr.success("Success", `Participant marked as ${attendeeValue ? "attended" : "unattended"}`);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    } finally {
      setAttendeeLoading(false);
      setAttendeeDialog(false);
      setAttendeeRow(null);
      setAttendeeValue(null);
      setAttendeeDateName("");
    }
  };

  return isEventsActive == false ? (
    <NotAuthorized title={"Events"} />
  ) : (
    <div className="family-table-container">
      <div className="my-auto page-header">
        <Text className="sub-title pt-3" style={{ height: 44 }}>
          Events
        </Text>
      </div>
      <div className="home-table-container mt-0">
        <TableContainer>
          <Table className="charges-table">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: 48 }} />
                <TableCell>EVENT NAME</TableCell>
                <TableCell>FIRST NAME</TableCell>
                <TableCell>LAST NAME</TableCell>
                <TableCell>PAYMENT STATUS</TableCell>
                <TableCell>TOTAL PAID</TableCell>
                <TableCell>ATTENDED</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <div className="user__loader" style={{ height: "320px" }}>
                      <Loader />
                    </div>
                  </TableCell>
                </TableRow>
              ) : list.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <h6>No Events Found</h6>
                  </TableCell>
                </TableRow>
              ) : (
                list.map((row) => (
                  <React.Fragment key={row._id}>
                    <TableRow
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setDrawerData(row);
                        setOpenDrawer(true);
                      }}
                    >
                      <TableCell style={{ padding: "0 4px" }} onClick={(e) => e.stopPropagation()}>
                        {row?.event?.multiEvents && (
                          <IconButton
                            aria-label="expand row"
                            size="large"
                            onClick={() => toggleRow(row._id)}
                            className="expandale-icon"
                            style={{ marginLeft: "8px" }}
                          >
                            {expandedRows[row._id] ? (
                              <IndeterminateCheckBoxOutlinedIcon style={{ fill: "#3f4255" }} />
                            ) : (
                              <AddBoxOutlinedIcon style={{ fill: "#3f4255" }} />
                            )}
                          </IconButton>
                        )}
                      </TableCell>
                      <TableCell>{row?.event?.eventName}</TableCell>
                      <TableCell>{row?.firstName}</TableCell>
                      <TableCell>{row?.lastName}</TableCell>
                      <TableCell>
                        <StatusWrapper>
                          <Status type={row?.registrationStatus}>
                            {row?.registrationStatus || "pending"}
                          </Status>
                        </StatusWrapper>
                      </TableCell>
                      <TableCell style={{ color: "green" }}>
                        {numberFormat({
                          number: row?.payment?.register?.totalPaid || 0,
                          decimal: 2,
                          style: "currency",
                        })}
                      </TableCell>
                      <TableCell onClick={(e) => e.stopPropagation()}>
                        {!row?.event?.multiEvents && (
                          <CheckBox
                            text=""
                            checked={row._id in attendedMap ? attendedMap[row._id] : !!row?.attended}
                            onChange={() => {
                              const current = row._id in attendedMap ? attendedMap[row._id] : !!row?.attended;
                              handleAttendeeChange(row, !current, "");
                            }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    {row?.event?.multiEvents && (
                      <TableRow>
                        <TableCell colSpan={7} style={{ padding: 0, border: 0 }}>
                          <Collapse in={!!expandedRows[row._id]} timeout="auto" unmountOnExit>
                            <Box>
                              <Table size="small" aria-label="event-dates">
                                <TableHead>
                                  <TableRow style={{ background: "#f3f6f9" }}>
                                    <TableCell style={{ border: "none" }} />
                                    <TableCell style={{ border: "none" }}>
                                      <span style={{ fontFamily: fontConfig.MemberDetailsEventsTextFont.family, fontWeight: 600, fontSize: "11px", lineHeight: "32px", color: "#4d5565" }}>EVENT NAME</span>
                                    </TableCell>
                                    <TableCell style={{ border: "none" }}>
                                      <span style={{ fontFamily: fontConfig.MemberDetailsEventsTextFont.family, fontWeight: 600, fontSize: "11px", lineHeight: "32px", color: "#4d5565" }}>UPDATED AT</span>
                                    </TableCell>
                                    <TableCell style={{ border: "none" }}>
                                      <span style={{ fontFamily: fontConfig.MemberDetailsEventsTextFont.family, fontWeight: 600, fontSize: "11px", lineHeight: "32px", color: "#4d5565" }}>ATTENDED</span>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {(row?.eventsDates || []).map((dateEntry, idx) => {
                                    const dateKey = dateEntry.name;
                                    const mapKey = `${row._id}__${dateKey}`;
                                    const isAttended = mapKey in dateAttendanceMap
                                      ? dateAttendanceMap[mapKey]
                                      : !!dateEntry?.attended;
                                    // the event's current date for this registration (dates can be moved after people register)
                                    const registeredDate = getCurrentRegisteredDate(dateEntry, row?.event?.multiEventsDates);
                                    const localDateStr = registeredDate
                                      ? new Date(registeredDate)
                                          .toLocaleString("en-US", {
                                            month: "numeric",
                                            day: "numeric",
                                            year: "numeric",
                                            hour: "numeric",
                                            minute: "2-digit",
                                          })
                                          .replace(",", "")
                                      : "-";
                                    const eventNameDisplay = [dateEntry.label, dateEntry.variant, localDateStr]
                                      .filter(Boolean)
                                      .join(" - ");
                                    return (
                                      <TableRow key={idx} style={{ background: "rgb(249, 251, 252)" }}>
                                        <TableCell style={{ border: "none" }} />
                                        <TableCell style={{ border: "none", fontFamily: fontConfig.MemberDetailsTableCellFont.family, fontWeight: 500, fontSize: "14px", color: "#4D5565" }}>
                                          {eventNameDisplay}
                                        </TableCell>
                                        <TableCell style={{ border: "none", fontFamily: fontConfig.MemberDetailsTableCellFont.family, fontWeight: 500, fontSize: "14px", color: "#4D5565" }}>
                                          {row?.updatedAt ? formatDate({ date: row.updatedAt, formatType: "defaultWithTime" }) : "-"}
                                        </TableCell>
                                        <TableCell style={{ border: "none" }}>
                                          <CheckBox
                                            text=""
                                            checked={isAttended}
                                            onChange={() => handleAttendeeChange(row, !isAttended, dateKey)}
                                          />
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div className="pagination-custom" style={{ marginTop: "20px" }}>
        <Pagination
          count={Math.ceil(total / 30)}
          color="primary"
          variant="outlined"
          onChange={(event, value) => {
            setPage(value - 1);
          }}
        />
      </div>
      <RightDrawer open={openDrawer} onClose={closeModal}>
        <ParticipantDrawer
          drawerData={drawerData}
          closeModal={() => {
            setOpenDrawer(false);
          }}
          getClassParticipants={getEventParticipantsHandler}
        />
      </RightDrawer>
      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
      <AlertDialog
        open={attendeeDialog}
        onDecline={() => {
          setAttendeeDialog(false);
          setAttendeeRow(null);
          setAttendeeValue(null);
        }}
        onAccept={confirmAttendee}
        title={"Are you sure?"}
        description={attendeeValue ? "Do you want to mark participant as attended?" : "Do you want to mark participant as unattended?"}
        disabled={attendeeLoading}
      />
    </div>
  );
};

export default Events;
